import { faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IValidationListItemProps {
  visible: boolean;
  isValid: boolean;
  label: string;
}
export const ValidationListItem = ({ visible, isValid, label }: IValidationListItemProps) => {
  if (!visible) return;
  const className = isValid ? 'text-success' : 'text-danger';
  const icon = isValid ? faCircleCheck : faTriangleExclamation;
  return (
    <li>
      <FontAwesomeIcon className={`me-2 status-icon ${className}`} icon={icon} />
      {label}
    </li>
  );
};
